<template>
  <div class="row">
    <div class="col-lg-12">
      <waitingForDocsSearch :units="this.units" @filtered-wo-data="updateTableData" />
    </div>
    <div class="col-lg-12">
      <!-- Table -->
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Documents</h4>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input v-model="filterTableData" type="search" placeholder="Search..."
                    class="form-control form-control-sm ml-2"></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <div class="row justify-content-start">
            <div class="col-12 d-flex justify-content-end">
              <b-button @click="exportToPDF" :disabled="disableExportButton" variant="primary" class="mb-2 mr-2">Export to PDF</b-button>
              <b-button @click="exportToCSV" :disabled="disableExportButton" variant="primary" class="mb-2">Export to CSV</b-button>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table :items="tableData" :fields="fields" ref="waitingForDocsTable" style="text-align: center" :per-page="perPage" :current-page="currentPage" :filter="filterTableData">
                <template v-slot:cell(workOrder)="data">
                  <router-link :to="{
                    name: 'workOrders',
                    params: { wonumber: data.item.workOrderNumber, wodate: data.item.workOrderDate }
                  }">
                    <p>{{ data.item.workOrderNumber }}</p>
                  </router-link>
                </template>
                <template v-slot:cell(workOrderDate)="data">
                  <p>{{ momentInstance(data.item.workOrderDate).format('ll') }}</p>
                </template>
                <template v-slot:cell(workOrderUnits)="data">
                  <div>
                    <div v-for="(unit) in data.item.workOrderUnits" :key="unit">
                      <b-badge :variant="'primary'" class="ml-2">{{ getUpToDateUnitName(unit) !== null ?
                        getUpToDateUnitName(unit)
                        : `` }}
                      </b-badge>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(issue)="data">
                  <div class="text-left">
                    <p>{{data.item.issue}}</p>
                  </div>
                </template>
                <template v-slot:cell(repair)="data">
                  <div class="text-left">
                    <p>{{data.item.repair}}</p>
                  </div>
                </template>
                <template v-slot:cell(repairedBy)="data">
                  <div v-for="repair in data.item.repairedBy" :key="repair.id">
                    <p v-if="repair.id">{{ repair.name }} on {{ momentInstance(repair.date).format('ll') }}</p>
                  </div>
                </template>
                <template v-slot:cell(repairCost)="data">
                  <p v-if="data.item.repairCost && data.item.repairCost.trim() !== ''">${{ data.item.repairCost }}</p>
                </template>
                <template v-slot:cell(repairHours)="data">
                  <p v-if="data.item.repairHours && data.item.repairHours.trim() !== ''">${{ data.item.repairHours }}</p>
                </template>
                <template v-slot:cell(sourceOfParts)="data">
                  <div class="text-left">
                    <p>{{data.item.sourceOfParts}}</p>
                  </div>
                </template>
                <template v-slot:cell(documents)="data">
                  <b-button v-if="Array.isArray(data.item.documents) && data.item.documents.length > 0" size="sm"
                    @click="data.toggleDetails" class="mt-1" style="max-width: 150px" variant="primary">
                    {{ data.detailsShowing ? 'Hide' : 'View' }}
                  </b-button>
                </template>
                <template #row-details="row">
                  <div v-if="row.item.documents !== null" class="d-flex flex-wrap">
                    <div v-for="(document, index) in row.item.documents" :key="index" style="text-align: center"
                      class="ml-4 mr-4 mb-4 mt-4">
                      <div class="d-flex justify-content-center">
                        <b-img v-if="document.file.name && document.file.type !== 'application/pdf'" thumbnail
                          class="data-dz-thumbnail ml-4 mr-4 mb-1 mt-4 document" :src="document.url"
                          :alt="document.file.name" style="
                              width: 160px;
                              height: 200px;
                              object-fit: contain;
                              cursor: pointer;
                            " @click="populateImage(document)" />

                        <div v-else-if="document.file.name && document.file.type == 'application/pdf'"
                          @click="populateImage(document)" class="data-dz-thumbnail mb-1 mt-4 document"
                          style="position: relative; width: 160px; height: 200px; cursor: pointer;">
                          <iframe :src="document.url" style="
                                width: 160px;
                                height: 200px;
                                border: none;
                                z-index: 1;
                                overflow: hidden;
                              " scrolling="no"></iframe>

                          <!-- had to add transparent overlay to make the iFrame clickable -->
                          <div style="
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 100%;
                                background-color: transparent;
                                z-index: 2;
                              "></div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-center">
                        <b-badge variant="primary" class="mb-4" style="font-size: 105%">{{
                          formattedFileName(document.file.name) }}</b-badge>
                      </div>
                      <div class="d-flex justify-content-center">
                        <div class="mb-3">
                          <b-button @click="onFileDownloaded(document)" variant="info" size="sm">Download</b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(UploadedBy)="data">
                  <a class="badge badge-primary font-size-15 mr-2 no-pointer">
                    {{ data.item.uploadedBy.name }}
                  </a>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Table -->
      </div>
    </div>

    <!-- Show Image Modal -->
    <b-modal id="img-modal" size="xl" hide-footer>
      <div v-if="selectedImage.file.name" style="text-align: center">
        <div class="d-block text-center">
          <iframe v-if="selectedImage.file.type === 'application/pdf'" :src="selectedImage.url" style="
                  width: 100%; 
                  height: 70vh; 
                  border: none;
                "></iframe>

          <img v-else :src="selectedImage.url" class="img-fluid" :alt="selectedImage.file.name" />
        </div>
        <div class="mt-3">
          <b-badge style="font-size: 150%" variant="primary">{{
            formattedFileName(selectedImage.file.name)
          }}</b-badge>
        </div>
        <div>
          <b-badge variant="success" style="font-size: 110%" class="mt-3">Uploaded By:</b-badge>
          <p style="font-size: 110%">
            {{ selectedImage.uploadedBy.name }} on
            {{ momentInstance(selectedImage.date).format('lll') }}
          </p>
        </div>
        <div class="mt-3">
          <b-button @click="onFileDownloaded(selectedImage)" variant="info" class="mr-4">Download</b-button>
          <b-button variant="light"><a :href="selectedImage.url" target="_blank">View In Browser</a>
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- /Show Image Modal -->
  </div>
</template>

<script>
import Vue from 'vue';
import appConfig from '@/app.config';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
import waitingForDocsSearch from './waitingForDocsSearch.vue';
import firebase from 'firebase';
import { getUnits } from '../../../../helper/dbHelpers.js';
import moment from 'moment';
import axios from 'axios';
import lodash from 'lodash';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { logo } from '../../../../assets/images/kaliLogo.js';

export default {
  page: {
    title: 'Waiting for Documents Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    waitingForDocsSearch
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'Date',
      sortDesc: false,
      units: [],
      searchUnit: null,
      searchStartDate: null,
      searchEndDate: null,
      tableData: [],
      loading: false,
      currentUser: this.$store.state.custom.currentUserData,
      momentInstance: moment,
      selectedImage: {
        url: null,
        file: { name: null, size: null, type: null },
      },
      filterTableData: null,
    };
  },
  computed: {
    fields() {
      const settings = this.$store.state.custom.workOrders;
      return [
        { key: 'workOrder', label: 'Work Order', sortable: true },
        { key: 'workOrderDate', label: 'Work Order Date', sortable: true },
        { key: 'workOrderUnits', label: 'Work Order Units', sortable: true },
        { key: 'issue', label: 'Issue', sortable: true },
        { key: 'repair', label: 'Repair', sortable: true },
        { key: 'repairedBy', label: 'Repaired By', sortable: true },
        ...(settings.repair_cost_enabled ? [{ key: 'repairCost', label: 'Parts Cost', sortable: true }] : []),
        ...(settings.repair_hours_enabled ? [{ key: 'repairHours', label: 'Labour Cost', sortable: true }] : []),
        ...(settings.labour_hours_enabled ? [{ key: 'labourHours', label: 'Labour Hours', sortable: true }] : []),
        { key: 'sourceOfParts', label: 'Source of Parts', sortable: true },
        { key: 'documents', label: 'Documents', sortable: true },
      ];
    },
    rows() {
      return this.tableData.length;
    },
    disableExportButton() {
      return this.tableData.length === 0;
    },
  },
  watch: {
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if (currentUserDataCopy.tablePageLengths.perPage_maintenance_waitingForDocs) {
            oldCurrentUserPerPage =
              currentUserDataCopy.tablePageLengths.perPage_maintenance_waitingForDocs;
          }
          currentUserDataCopy.tablePageLengths['perPage_maintenance_waitingForDocs'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_maintenance_waitingForDocs: newVal,
          };
        }

        if (oldCurrentUserPerPage !== newVal) {
          try {
            firebase
              .firestore()
              .collection('employees')
              .doc(this.currentUser.auth)
              .update({
                tablePageLengths: currentUserDataCopy.tablePageLengths,
              });
          } catch (err) {
            console.log('Error updating user table settings in db: ', err);
          }
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
  methods: {
    getIntitialUnits() {
      getUnits()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let unit = doc.data();
            unit['docID'] = doc.id;
            this.units.push(unit);
          });
        })
        .catch(() => {
          console.log(`Error getting Units...`);
        });
    },
    setTableSettings: function () {
      this.currentUser = this.$store.state.custom.currentUserData;
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_maintenance_waitingForDocs) {
          this.perPage = this.currentUser.tablePageLengths.perPage_maintenance_waitingForDocs;
        }
      }
    },
    updateTableData: function (filteredWorkOrderData) {
      this.tableData = filteredWorkOrderData;
    },
    getUpToDateUnitName: function (unitUid) {
      let upToDateUnitName = null;
      const unitIndex = this.units.findIndex((x) => x.docID === unitUid);
      if (unitIndex !== -1) {
        upToDateUnitName = this.units[unitIndex].name;
      }
      return upToDateUnitName;
    },
    populateImage(document) {
      this.selectedImage = lodash.cloneDeep(document);
      this.$bvModal.show('img-modal');
    },
    formattedFileName: function (fileName) {
      return fileName.substring(fileName.indexOf('-') + 1);
    },
    onFileDownloaded: async function (file) {
      axios
        .get(file.url, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.formattedFileName(file.file.name);
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          console.log(error);
          Vue.$toast.open({
            message: 'Error downloading document',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        });
    },
    async exportToPDF() {
      // fields to exclude
      const excludeFields = ['repairedBy', 'repairHours', 'repairCost', 'labourHours', 'sourceOfParts', 'documents', 'units'];

      // filter fields and create headers
      const filteredFields = this.fields.filter(field => !excludeFields.includes(field.key));
      const headers = filteredFields.map(field => ({
        text: field.label || field.key,
        bold: true,
        fontSize: 12,
        margin: [0, 5, 0, 5],
      }));

      // prepare rows of data
      const rows = this.tableData.map((item) => {
        return filteredFields.map((field) => {
          let text = '';
          if (field.key === 'workOrder') {
            text = item['workOrderNumber'] ? item['workOrderNumber'].toString() : '';
          } else if (field.key === 'workOrderDate') {
            text = item['workOrderDate'] ? moment(item['workOrderDate']).format('ll') : '';
          } else if (field.key === 'workOrderUnits') {
            text = Array.isArray(item['workOrderUnits'])
              ? item['workOrderUnits']
                .map(unit => this.getUpToDateUnitName(unit).trim())
                .join(', ')
              : '';
          } else {
            text = item[field.key] ? item[field.key].toString() : '';
          }

          return { text, fontSize: 12, margin: [0, 2, 0, 2] };
        });
      });

      // create table structure for pdfmake
      const docDefinition = {
        content: [
          {
            table: {
              widths: ['*', 'auto'],
              body: [
                [
                  {
                    text: 'Waiting for Documents Report',
                    style: 'header',
                    border: [false, false, false, true]
                  },
                  {
                    image: logo,
                    style: 'logo',
                    fit: [100, 100],
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
            margin: [0, 0, 0, 10],
          },
          '\n\n',
          {
            table: {
              headerRows: 1,
              widths: Array(filteredFields.length).fill('*'),
              body: [
                headers,
                ...rows,
              ],
            },
          },
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
          },
        },
      };

      pdfMake.createPdf(docDefinition).download(`Waiting for Docs Report - ${moment(new Date()).format('ll')}.pdf`);
    },
    exportToCSV() {
      // fields to exclude
      const excludeFields = ['units'];

      // function to sanitize string inputs for CSV
      const sanitizeString = (str) => {
        if (typeof str !== 'string') return '';
        return str
          .replace(/[\n\r]/g, '')
          .replace(/,/g, ' ');
      };

      // filter fields and create headers
      const filteredFields = this.fields.filter(field => !excludeFields.includes(field.key));
      const headers = filteredFields.map(field => sanitizeString(field.label || field.key));

      const rows = this.tableData.map(item => {
        return filteredFields.map(field => {
          if (field.key === 'workOrder') {
            return sanitizeString(item['workOrderNumber'] ? item['workOrderNumber'].toString() : '');
          } else if (field.key === 'workOrderDate') {
            return sanitizeString(item['workOrderDate'] ? moment(item['workOrderDate']).format('YYYY-MM-DD') : '');
          } else if (field.key === 'workOrderUnits') {
            return Array.isArray(item['workOrderUnits'])
              ? sanitizeString(
                item['workOrderUnits']
                  .map(unit => this.getUpToDateUnitName(unit).trim())
                  .join(', ')
              )
              : '';
          } else if (field.key === 'repairedBy') {
            return Array.isArray(item['repairedBy']) && item['repairedBy'][0].id
              ? sanitizeString(
                item['repairedBy']
                  .map(repairMan => `${repairMan.name.trim()} on ${moment(repairMan.date).format('YYYY-MM-DD')}`)
                  .join(', ')
              )
              : '';
          } else if (field.key === 'documents') {
            return Array.isArray(item['documents'])
              ? sanitizeString(
                item['documents']
                  .map(doc => `${doc.file.name.trim().split('-').slice(1).join('-')} (${moment(doc.date).format('YYYY-MM-DD')})`)
                  .join(', ')
              )
              : '';
          } else {
            return sanitizeString(item[field.key] ? item[field.key].toString() : '');
          }
        });
      });

      // convert headers and rows to CSV format
      const csvContent = [
        headers.join(','),
        ...rows.map(row => row.join(','))
      ].join('\n');

      // create a blob and trigger a download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `Waiting for Docs Report - ${moment(new Date()).format('ll')}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  created: function () {
    this.getIntitialUnits();
    this.setTableSettings();
  },
};
</script>